var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content price-fcl" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "fcl-search-bar",
            {
              ref: "searchBar",
              attrs: {
                "is-show-sale-state": true,
                "is-query-price": true,
                "show-currency": false,
                "is-manage-module": true,
                "is-show-contract-no": true,
                filter: _vm.filter,
                "is-cp": _vm.activeTabName === "cpList",
                "config-id": "PriceFCL",
                "disabled-freight-type": !_vm.isCp
              },
              on: {
                onLevelChanged: _vm.onLevelChanged,
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery,
                reset: _vm.resetQuery
              }
            },
            [
              _vm.activeTabName === "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEditCP2",
                            type: "success",
                            disabled: !this.cpSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onDeleteCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Invalid")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(0)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Common")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(1)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Suspend")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(2)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Reject")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(3)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Inquiry")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(4)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PriceState_Lack")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onPriceStateCP2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onPriceState_CP(5)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Pricing.PriceState_Overbooked"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: {
                            no: "onDownloadTemplateRelease2",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDownloadTemplateRelease()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "saveExcelFile2",
                            action: _vm.URL.price.saveExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadExcelSuccess,
                            data: { isRelease: true, branchId: _vm.branchId },
                            "on-progress": _vm.uploadProcess
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "onImportFileRelease",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onImportFileRelease()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeTabName !== "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEditCP",
                            type: "success",
                            disabled: !this.ppSelectRow && !_vm.spotPpSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "onDeletePP",
                            type: "danger",
                            disabled:
                              !this.selectedPpCount && !this.selectedSpotPpCount
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.approveAllowed_PP,
                              expression: "approveAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onApprovePP2",
                            disabled:
                              !this.selectedPpCount &&
                              !this.selectedSpotPpCount,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onApprove_PP2()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.SchemeAudit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.approveAllowed_PP,
                              expression: "approveAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onApprovePP",
                            disabled:
                              !this.selectedPpCount &&
                              !this.selectedSpotPpCount,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onApprove_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.ManualAudit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.priceFclUtil.isApprove,
                              expression: "priceFclUtil.isApprove"
                            }
                          ],
                          attrs: { no: "onConfigPriceFcl", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onConfigPriceFcl()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Setting")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onAddPP", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onAdd_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onDownloadTemplate", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onDownloadTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "saveExcelFile",
                            action: _vm.URL.price.saveExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadExcelSuccess,
                            "on-error": _vm.uploadExcelError,
                            data: { isRelease: false, branchId: _vm.branchId },
                            "on-progress": _vm.uploadProcess
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "onImportFilePP", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.onImportFile_PP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.inputAllowed_PP &&
                                _vm.activeTabName === "spotPpList",
                              expression:
                                "inputAllowed_PP && activeTabName === 'spotPpList'"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "saveExcelFile",
                            action: _vm.URL.price.saveGeekYumExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "on-success": _vm.uploadGeekYumExcelSuccess,
                            "on-error": _vm.uploadExcelError,
                            data: { isRelease: false, branchId: _vm.branchId },
                            "on-progress": _vm.uploadProcess
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "onGeekYumImportFilePP",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onImportFile_PP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.GeekYumImport")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.inputAllowed_PP &&
                                _vm.activeTabName === "spotPpList",
                              expression:
                                "inputAllowed_PP && activeTabName === 'spotPpList'"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "oneStackExcelFile",
                            action: _vm.URL.price.saveOneStackExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "on-success": _vm.uploadGeekYumExcelSuccess,
                            "on-error": _vm.uploadExcelError,
                            data: { isRelease: false, branchId: _vm.branchId },
                            "on-progress": _vm.uploadProcess
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "oneStackExcelFilePP",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onImportFile_PP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.OneStackImport")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.CurrentPrice"),
                    name: "cpList"
                  }
                },
                [
                  _c("fcl-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "cpList",
                      "config-module": "221301",
                      "row-data": _vm.rowCpData,
                      "show-price-no": true,
                      "show-approve": true,
                      filter: _vm.filter,
                      "grid-options": _vm.cpGridOptions,
                      view: 1
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label:
                      _vm.$t("Pricing.TraditionalFreightRates") +
                      _vm.$t("Pricing.PendingPrice"),
                    name: "ppList"
                  }
                },
                [
                  _c("fcl-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "ppList",
                      "config-module": "221302",
                      "row-data": _vm.rowPpData,
                      "show-price-no": false,
                      "show-approve": false,
                      filter: _vm.filter,
                      "grid-options": _vm.ppGridOptions,
                      view: 0
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label:
                      _vm.$t("Pricing.SpotFreightRates") +
                      _vm.$t("Pricing.PendingPrice"),
                    name: "spotPpList"
                  }
                },
                [
                  _c("fcl-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "spotPpList",
                      "config-module": "221303",
                      "row-data": _vm.rowSpotPpData,
                      "show-price-no": false,
                      "show-approve": false,
                      filter: _vm.filter,
                      "grid-options": _vm.spotPpGridOptions,
                      view: 0
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                left: "270px",
                margin: "10px"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.globalMsg))])]
          )
        ],
        1
      ),
      _vm.fclFormDialog.visible
        ? _c("fcl-form", {
            attrs: {
              visible: _vm.fclFormDialog.visible,
              "source-price": _vm.fclFormDialog.sourcePrice,
              price: _vm.fclFormDialog.price,
              "is-new": _vm.fclFormDialog.isNew,
              "is-cp": _vm.activeTabName === "cpList",
              "disabled-freight-type": !_vm.isCp
            },
            on: {
              close: _vm.onFclFormDialogClose,
              deleteCp: _vm.deleteCp,
              reload: _vm.toQuery,
              clearGrid: _vm.clearGrid
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.priceStateRejectDialog.visible,
            title: this.$t("Pricing.PriceState_Reject"),
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.priceStateRejectDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticStyle: { width: "100%" } }, [
            _c("div", { staticStyle: { margin: "10px", color: "blue" } }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("Pricing.PlsSelectRejectEQ")))])
            ]),
            _c(
              "div",
              { staticStyle: { "text-align": "center" } },
              [
                _c("el-checkbox", {
                  attrs: { no: "reject20", label: "20'" },
                  model: {
                    value: _vm.priceStateRejectDialog.price.reject20,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.priceStateRejectDialog.price,
                        "reject20",
                        $$v
                      )
                    },
                    expression: "priceStateRejectDialog.price.reject20"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { no: "reject40", label: "40'" },
                  model: {
                    value: _vm.priceStateRejectDialog.price.reject40,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.priceStateRejectDialog.price,
                        "reject40",
                        $$v
                      )
                    },
                    expression: "priceStateRejectDialog.price.reject40"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { no: "rejectHC", label: "40'HC" },
                  model: {
                    value: _vm.priceStateRejectDialog.price.rejectHC,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.priceStateRejectDialog.price,
                        "rejectHC",
                        $$v
                      )
                    },
                    expression: "priceStateRejectDialog.price.rejectHC"
                  }
                }),
                _c("el-checkbox", {
                  attrs: { no: "reject45", label: "45'" },
                  model: {
                    value: _vm.priceStateRejectDialog.price.reject45,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.priceStateRejectDialog.price,
                        "reject45",
                        $$v
                      )
                    },
                    expression: "priceStateRejectDialog.price.reject45"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.rejectOk }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.priceStateRejectDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("fcl-markup-scheme-dialog", {
        ref: "schemeDialog",
        attrs: {
          visible: _vm.fclMarkupSchemeDialog.visible,
          "selected-rows": _vm.fclMarkupSchemeDialog.selectedRows,
          "is-spot": _vm.activeTabName === "spotPpList"
        },
        on: {
          close: _vm.onFclMarkupSchemeDialogClose,
          auditBack: _vm.auditBack
        }
      }),
      _c("fcl-markup-manual-dialog", {
        ref: "manualDialog",
        attrs: {
          visible: _vm.fclMarkupManualDialog.visible,
          "is-spot": _vm.activeTabName === "spotPpList"
        },
        on: {
          close: _vm.onFclMarkupManualDialogClose,
          auditBack: _vm.auditBack
        }
      }),
      _c("fcl-settings-dialog", {
        ref: "settingsDialog",
        attrs: { visible: _vm.fclSettingsDialog.visible },
        on: { close: _vm.onFclSettingsDialogClose }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }